import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Icon, Segment } from 'semantic-ui-react';
import Chart from '../../nacre/components/chart';
import StatsQueueModel from '../../models/statsQueue';
import { useTranslation } from 'react-i18next';
import Loading from '../../components/loading';
import { WeezHeader } from '@weezevent/nacre';

export default function QueueChart({ stats = null, title = '', displayHeader = false }) {
    const { t } = useTranslation();
    const [statsToDisplay, setStats] = React.useState(stats);

    React.useEffect(() => {
        if (!stats) {
            //fetch stats
            StatsQueueModel.get({})
                .then(response => {
                    setStats(response);
                })
                .catch(e => {});
        }
    }, [stats]);

    if (statsToDisplay) {
        const dataLine = [];
        Object.values(statsToDisplay.object)
            .slice(0)
            .map((statData, index) => {
                const delta = Object.values(statsToDisplay.object).length - index;
                let object = {
                    name: '-' + delta + 'm'
                };
                object[t('ticket.queue.charts.processing')] = statData.processed;
                object[t('ticket.queue.charts.waiting')] = statData.waiting;
                object[t('ticket.queue.charts.left')] = statData.left;

                dataLine.push(object);

                return null;
            });
        const labels = [
            { value: t('ticket.queue.charts.processing'), color: '#3DCC91' },
            { value: t('ticket.queue.charts.waiting'), color: '#FFB366' },
            { value: t('ticket.queue.charts.left'), color: '#FF7373' }
        ];
        return (
            <>
                {displayHeader && <WeezHeader title={t('ticket.queue.title_admin')} />}
                {title && <h3 style={{ marginTop: '15px' }}>{title}</h3>}
                <Grid className="queue charts-container">
                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                            <Segment>
                                <Chart data={dataLine} labels={labels} />
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                            <Segment>
                                <p className="legend-container">
                                    {' '}
                                    {labels.map(legend => {
                                        return (
                                            <span key={legend.value} className="legend">
                                                <Icon name="square full" style={{ color: legend.color }} /> {legend.value}
                                            </span>
                                        );
                                    })}{' '}
                                </p>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </>
        );
    } else {
        return <Loading />;
    }
}

QueueChart.propTypes = {
    t: PropTypes.func.isRequired,
    stats: PropTypes.object.isRequired,
    displayHeader: PropTypes.bool
};
